:host {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 350px;
    font-family: system-ui, sans-serif;
    
    border: 0.5px solid var(--border) !important;
    border-radius: 12px;
    background: var(--secondary);
    overflow: hidden;
}


.ng-head {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    column-gap: 8px;
    padding: 8px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.12);
    font-size: 13px;
    color: #ccc;
}

.ng-icon {
    flex: none;
    vertical-align: middle;
    position: relative;
    top: -1px;
}


.ng-title {
    justify-self: start;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    overflow: hidden;

}

.ng-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
}


.ng-center {
    justify-self: center;
    display: flex;
    align-items: center;
    gap: 8px;
}

.ng-right {
    justify-self: end;
}

.ng-expand-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid var(--ring);
    background: transparent;
    color: #ccc;
    transition: background 0.15s, transform 0.1s;
}


.ng-expand-btn:hover {
    background: rgba(255,255,255,0.08);
}

.ng-walklink {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid var(--ring);
    background: transparent;
    color: #ccc;
    transition: background 0.15s, transform 0.1s;
}


.ng-walklink:hover {
    text-decoration: underline;
    background: rgba(255,255,255,0.08);
}

.ng-stepper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ng-walklink[hidden],
.ng-stepper[hidden] {
    display: none;
}


.ng-stepbtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border-radius: 8px;
    border: 1px solid var(--ring);
    background: transparent;
    color: #ccc;
    line-height: 1;
    font-size: 14px;
    transition: background 0.15s, transform 0.1s;
}


.ng-stepbtn:hover {
    background: rgba(255,255,255,0.08);
}

.ng-stepbtn[disabled] {
    opacity: 0.3;
    pointer-events: none;
}

.ng-steplabel {
    font-size: 12px;
    text-align: center;
    min-width: 140px;
    white-space: nowrap;
}

.ng-stepcount {
    font-size: 10px;
    color: #888;
    display: block;
    height: 10px;
}

.ng-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: var(--card);
    flex: auto;
}

.ng-status {
    padding: 1rem;
    color: #666;
    font-size: 0.9rem;
}

.ng-canvas {
    position: relative;
    transform-origin: 0 0;
    transition: transform .4s cubic-bezier(.22, .8, .2, 1);
}


.ng-node {
    position: absolute;
    transition: opacity .2s ease;
}

.ng-node.ng-dim {
    opacity: 0.28;
}

.ng-edge {
    transition: opacity .2s ease;
}